import { render, staticRenderFns } from "./StudioControls.vue?vue&type=template&id=978abde4&scoped=true&"
import script from "./StudioControls.vue?vue&type=script&lang=js&"
export * from "./StudioControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978abde4",
  null
  
)

export default component.exports